module.exports = __webpack_public_path__ + "static/pet_web_store_cover-958dc11eea8f760d96fa456f762698a9.png";